export default {
  en: {
    title: 'Brand Assets',
  },
};
